import memoizeOne from 'memoize-one';
import type { NodeComponentsProps } from '@atlaskit/renderer';
import cardRendererNodes from '@atlaskit/renderer/experimental-sync-custom-nodes/cards';
import mediaRendererNodes from '@atlaskit/renderer/experimental-sync-custom-nodes/media';
import smallRendererNodes from '@atlaskit/renderer/experimental-sync-custom-nodes/small-nodes';

export const getSyncRendererNodeOverrides = memoizeOne(
	(): NodeComponentsProps => ({
		...cardRendererNodes,
		...mediaRendererNodes,
		...smallRendererNodes,
	}),
);
